import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Checkbox } from 'primeng/checkbox';
import { ControlErrorDirective } from '../../../directive/control-error.directive';
import { InputMask } from 'primeng/inputmask';
import { DomesticBankAccountFormModel } from './form-group/domestic-bank-account-form.model';
import { InputText } from 'primeng/inputtext';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { RequiredLabelDirective } from '../../../directive/required-label.directive';

@Component({
  selector: 'app-form-domestic-bank-account',
  imports: [
    Checkbox,
    ReactiveFormsModule,
    ControlErrorDirective,
    InputMask,
    InputText,
    RequiredLabelDirective,
  ],
  templateUrl: './form-domestic-bank-account.component.html',
  styleUrl: './form-domestic-bank-account.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormDomesticBankAccountComponent implements OnInit {
  public formGroup = input.required<FormGroup<DomesticBankAccountFormModel>>();
  readonly #destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.#setAvailabilityOfOwnerDetailsControl();
    this.#subscribeToIsNotOwnerControlValueChanges();
  }

  #subscribeToIsNotOwnerControlValueChanges(): void {
    this.formGroup()
      .controls.nieJestWlascicielem.valueChanges.pipe(
        tap((value) => {
          this.#setAvailabilityOfOwnerDetailsControl();
          this.#resetOwnerDetailsControl(value);
        }),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe();
  }

  #setAvailabilityOfOwnerDetailsControl(): void {
    if (this.formGroup().controls.nieJestWlascicielem.value) {
      this.formGroup().controls.daneWlasciciela.enable();
    } else {
      this.formGroup().controls.daneWlasciciela.disable();
    }
  }

  #resetOwnerDetailsControl(nieJestWlascicielem: boolean | null): void {
    if (!nieJestWlascicielem) this.formGroup().controls.daneWlasciciela.reset();
  }

  moveAccountNumberCaret(event: Event) {
    const input = event.target as HTMLInputElement;
    const previousCaret = input.selectionStart ?? 0;

    requestAnimationFrame(() => {
      const value = input.value;
      let lastDigitPos = 0;

      for (let i = value.length - 1; i >= 0; i--) {
        if (/\d/.test(value[i])) {
          lastDigitPos = i + 1;
          break;
        }
      }
      if (previousCaret <= lastDigitPos) {
        input.setSelectionRange(previousCaret, previousCaret);
        return;
      }
      input.setSelectionRange(lastDigitPos, lastDigitPos);
    });
  }
}
